export const KB = 1024;
export const MB = 1024 * KB;
export const GB = 1024 * MB;
export const UNLIMITED_TRANSFER_LIMIT = null;
